export const RANDOM_POSITIONS_X = [
  "85%",
  "82%",
  "71%",
  "95%",
  "68%",
  "62%",
  "21%",
  "38%",
  "93%",
  "68%",
  "20%",
  "18%",
  "33%",
  "50%",
  "63%",
  "35%",
  "29%",
  "32%",
  "60%",
  "43%",
  "57%",
  "81%",
  "51%",
  "92%",
  "61%",
  "17%",
  "31%",
  "33%",
  "60%",
  "10%",
  "29%",
  "87%",
  "86%",
  "6%",
  "88%",
  "42%",
  "59%",
  "92%",
  "46%",
  "31%",
  "48%",
  "76%",
  "27%",
  "65%",
  "42%",
  "63%",
  "69%",
  "27%",
  "33%",
  "47%",
  "79%",
  "6%",
  "24%",
  "77%",
  "50%",
  "36%",
  "52%",
  "39%",
  "17%",
  "8%",
  "28%",
]

export const RANDOM_POSITIONS_Y = [
  "47%",
  "47%",
  "33%",
  "85%",
  "42%",
  "27%",
  "74%",
  "40%",
  "7%",
  "92%",
  "20%",
  "35%",
  "51%",
  "89%",
  "10%",
  "72%",
  "49%",
  "59%",
  "48%",
  "24%",
  "94%",
  "41%",
  "87%",
  "14%",
  "6%",
  "48%",
  "55%",
  "25%",
  "92%",
  "6%",
  "93%",
  "72%",
  "17%",
  "10%",
  "60%",
  "54%",
  "21%",
  "46%",
  "94%",
  "75%",
  "57%",
  "70%",
  "51%",
  "62%",
  "26%",
  "36%",
  "39%",
  "93%",
  "16%",
  "49%",
  "93%",
  "38%",
  "13%",
  "53%",
  "54%",
  "20%",
  "95%",
  "44%",
  "12%",
  "24%",
  "27%",
]
